import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import zhCN from 'antd/es/locale/zh_CN';
import App from './App.tsx';
import './i18n/index.ts';
import './index.css';

dayjs.locale('zh-cn');

// 将 runtime config 同步到 api-client 期望的 _intellix_server_config
// 使 api-client 的 authBaseURL (gatewayBaseUrl) 可以正确推导
const g = globalThis as any;
if (g._template_app_server_config && !g._intellix_server_config) {
  g._intellix_server_config = g._template_app_server_config;
}

// 创建 QueryClient 实例
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // 数据立即过期
      gcTime: 1000 * 60 * 5, // 5分钟后清理缓存
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Antd 国际化配置组件
const AntdConfigProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <ConfigProvider locale={zhCN}>{children}</ConfigProvider>;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AntdConfigProvider>
        <App />
      </AntdConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
